'use client';

import { COLORS } from '@/constants';
import styled from 'styled-components';

export const IntroCard = styled.div`
  border-radius: 10px;
  box-shadow: 0px 2px 4px 0px #7b63571a;
  overflow: hidden;
`;

export const IntroHero = styled.div`
  background: ${COLORS.blue};
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 0;
  min-height: 140px;
  position: relative;
  overflow: hidden;
`;

export const IntroHeroContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  padding: 28px 32px;
  flex: 1;
  min-width: 0;
  position: relative;
  z-index: 1;
`;

export const IntroHeroImage = styled.div`
  flex-shrink: 0;
  width: 260px;
  position: relative;
  overflow: hidden;

  @media (max-width: 700px) {
    display: none;
  }
`;

export const IntroFeatures = styled.div`
  background: ${COLORS.white};
  padding: 20px 24px 24px;
`;

export const IntroGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const IntroFeatureItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px;
  border-radius: 8px;
  background: ${COLORS['primary/50']};
`;

export const IntroFeatureIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: ${COLORS.white};
  color: ${COLORS['primary/500']};
  flex-shrink: 0;
`;

export const IntroFeatureText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
